import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FileReaderService } from '../file-reader.service';
import { CommonService } from '../common.service';
import { finalize } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-upload-patient-mrn',
  templateUrl: './upload-patient-mrn.component.html',
  styleUrls: ['./upload-patient-mrn.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class UploadPatientMRNComponent implements OnInit {
  @ViewChild('studyMappingStructureFileInput') studyMappingStructureFileInput: any;
  studyMappingForm: FormGroup = this.formBuilder.group({
    selectedFile: [],
  });
  selectedFileName: any = [];
  selectedFileData: any = [];
  tabSelected: number = 0;
  spinnerActive: boolean = false;

  // mrnInfo

  constructor(private fileReaderService: FileReaderService, private formBuilder: FormBuilder, public commonService: CommonService, private translate: TranslateService) {
    this.translate.addLangs(['en']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit(): void {
    this.studyMappingForm.controls['selectedFile'].valueChanges.subscribe((selectedFiles: any) => {
      if (selectedFiles.files.length) {
        this.fileReaderService.readFile(selectedFiles.files[0], (fileData: any) => {
          this.createMRNInfo(fileData);
        });
      }
    });
  }

  createMRNInfo(fileData: any) {
    // this.selectedFileData = Object.keys(fileData[0]).sort();
    let fileModifiedData: any = {};
    for (let x = 0; x < fileData.length; x++) {
      let indvData = fileData[x];
      if (!fileModifiedData[indvData.mrn_identifier]) {
        fileModifiedData[indvData.mrn_identifier] = {
          "mrnIdentifier": indvData.mrn_identifier,
          "caseStatus": indvData.case_status,
          "diagnosis": indvData.diagnosis,
          "labLocation": indvData.lab_location,
          "testDate": (new Date(indvData.test_date)).getTime(),
          "testType": indvData.test_type,
          "patientIdentifier": indvData.patient_identifier,
          "admissionDateTime": (new Date(indvData.admission_date)).getTime(),
          "pathologist": indvData.pathologist,
          "organ": indvData.organ ? indvData.organ : "PROSTATE",
          "slideList": [],
          "patientDTO": {
            "birthDate": (new Date(indvData.birth_date)).getTime(),
            "contactList": [
              {
                "id": null,
                "gender": indvData.gender,
                "name": indvData.patient_name,
                "organization": "HealthCare",
                "relationship": "SELF",
                "telecom": "Telecom",
                "patient": null,
                "addressList": [
                  {
                    "city": "DumCity",
                    "country": "DumCountry",
                    "district": "DumDistrict",
                    "line": "DumLine",
                    "postalCode": "DumPostalCode",
                    "state": "DumState",
                    "text": "Text",
                    "type": "Home",
                    "addressUse": "AddressUse"
                  }
                ],
                "isPatient": true
              }
            ],
            "admissionDateTime": (new Date(indvData.admission_date)).getTime(),
            "deceasedBoolean": 0,
            "gender": indvData.gender,
            "identifier": indvData.patient_identifier,
            "maritalStatus": 0,
            "multipleBirthBoolean": 0,
            "name": indvData.patient_name
          }
        }
      }

      fileModifiedData[indvData.mrn_identifier].slideList.push({
        // "slideLocation": this.getFilenameFromPath(indvData.slide_location),
        // "slideLocation": this.stringEscape(indvData.slide_location),
        "slideLocation": indvData.slide_location,
        "mrnIdentifier": indvData.mrn_identifier,
        "name": indvData.slide_name,
        "reviewStatus": indvData.slide_review_status,
        "stain": indvData.stain,
        "gender": indvData.gender,
        "organ": indvData.organ ? indvData.organ : "PROSTATE",
        "analysisFindings": indvData.analysis_findings
      });
    }
    this.selectedFileData = Object.values(fileModifiedData);;
  }

  getFilenameFromPath(path: any) {
    let separator = '/';
    var segmented = path.split(separator);
    return segmented[segmented.length - 1];
  }

  stringEscape(s: any) {
    return s ? s.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/'/g, "\\'").replace(/"/g, '\\"').replace(/[\x00-\x1F\x80-\x9F]/g, hex) : s;
    function hex(c: any) { var v = '0' + c.charCodeAt(0).toString(16); return '\\x' + v.substr(v.length - 2); }
  }

  SavePatientMRN() {
    this.spinnerActive = true;
    this.commonService.savePatientMRNSheetData(this.selectedFileData).pipe(finalize(() => this.spinnerActive = false)).subscribe((response: any) => {
      this.resetUpload();
      this.commonService.showToastMsg(this.translate.instant("UPLOAD_PATIENT_MRN.MRN_UPLOAD_SUCCESS"));
    });
  }

  resetUpload() {
    this.selectedFileData = null;
    this.selectedFileName = null;
    this.studyMappingForm = this.formBuilder.group({
      selectedFile: [],
    });
    this.studyMappingStructureFileInput = null;
  }

  selectFile(files: any) {
    this.selectedFileName = files[0]?.name;
    this.fileReaderService.readFile(files[0], (fileData: any) => {
      this.createMRNInfo(fileData);
    });
  }

}